<script setup>
import { CSAT_DISPLAY_TYPES } from 'shared/constants/messages';
import { computed } from 'vue';

// T-174: a escala numérica. O clube calcula a nota final da operação como média ponderada das
// respostas, e emoji ou estrela escondem o número que está sendo dado.
const props = defineProps({
  selected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update']);

const selectionClass = computed(() =>
  props.selected
    ? 'bg-n-brand/5 outline-n-brand'
    : 'bg-n-alpha-black2 outline-n-weak'
);
</script>

<template>
  <button
    class="flex items-center rounded-lg transition-all duration-300 cursor-pointer outline outline-1 px-4 py-2 gap-2 min-w-56"
    :class="selectionClass"
    @click="emit('update', CSAT_DISPLAY_TYPES.NUMBER)"
  >
    <span
      v-for="n in 5"
      :key="'nota-' + n"
      class="flex items-center justify-center flex-shrink-0 rounded-md size-7 text-sm font-semibold tabular-nums text-n-slate-12 bg-n-alpha-2"
    >
      {{ n }}
    </span>
  </button>
</template>
